import React, { useEffect, useState } from "react";
import { lib } from "../index";
import { Button, message, Modal, Select } from "antd";

export function BindRoleModal({ userId, userName, buttonType, onSuccess }) {
    let [visible, setVisible] = useState(false);
    let [list, setList] = useState([]);
    let [roleId, setRoleId] = useState([]);
    let url =
        lib.config.webToken == "admin" ? "/ucenter-admin/waiter/role/list" : "/ucenter-customer/user/sub/role/list";
    useEffect(() => {
        if (visible) {
            lib.request({
                url,
                data: {
                    userId,
                    systemCode: lib.config.systemCode,
                },
                success: list => {
                    setRoleId(list.filter(item => item.checked).map(item => item.id));
                    setList(list);
                },
            });
        }
    }, [visible]);
    return (
        <>
            {visible && (
                <Modal
                    open={true}
                    title={`绑定角色`}
                    width={600}
                    className="account-manage-bind-role"
                    maskClosable={false}
                    onCancel={() => setVisible(false)}
                    onOk={() => {
                        let url =
                            lib.config.webToken == "admin"
                                ? "/ucenter-admin/waiter/role/update"
                                : "/ucenter-customer/user/sub/updateRole";
                        lib.request({
                            url,
                            data: {
                                userId,
                                systemCode: lib.config.systemCode,
                                roleId,
                            },
                            needMask: true,
                            success: () => {
                                message.success("操作成功");
                                onSuccess();
                                setVisible(false);
                            },
                        });
                    }}>
                    <div className="item">
                        <label>用户名称：</label>
                        {userName}
                    </div>
                    <div className="item">
                        <label>角色选择（可多选):</label>
                        <Select
                            mode="multiple"
                            allowClear
                            style={{ width: "300px" }}
                            value={roleId}
                            showSearch={true}
                            optionFilterProp="children"
                            onChange={value => setRoleId(value)}>
                            {list.map(item => (
                                <Select.Option key={item.id} value={item.id}>
                                    {item.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                </Modal>
            )}
            {buttonType === "link" && (
                <a type={buttonType} onClick={() => setVisible(true)}>
                    绑定角色
                </a>
            )}
            {buttonType === "primary" && (
                <Button type={buttonType} onClick={() => setVisible(true)}>
                    角色管理
                </Button>
            )}
        </>
    );
}
